// @ts-nocheck
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Layout from "./component/layout";
import {
  Explore,
  HomePage,
  NotFoundPage,
  ReminderPage,
  ServicePage,
  SparePartPage,
  UsedCarsPage,
} from "./component/pages";

import PrivateRoute from "./component/PrivateRoute";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
// import { login } from "./redux/authSlice";
import Login from "./component/auth/Login";
import { login } from "./redux/authSlice";
import { useNavigate } from "react-router-dom";
import { Services } from "./component/Service/Services";
import { SpareParts } from "./component/SpareParts/SpareParts";
import { UsedCars } from "./component/UsedCars/UsedCars";
import { Chat } from "./component/Chat/Chat";
import { Customers } from "./component/Customers/Customers";
import { Offers } from "./component/Offers/Offers";
import { OrderHistory } from "./component/OrderHistory/OrderHistory";
import { Reminder } from "./component/Reminder/Reminder";
import Privacy from "./component/Privacy/Privacy";
import { UsedCarsEnquiriesTabel } from "./component/UsedCars/UsedCarsEnquiriesTabel";
// import TermsAndConditions from "./component/Privacy/TermsAndConditions";
import TermsAndConditions from "./component/Privacy/TermsAndConditions";
import LanguageSelector from "./component/settings/LanguageSelector";
import UnauthorizedIndex from "./component/unauthorized";
import { ErrorBoundary } from "react-error-boundary";

function App() {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  const [isMobile, setIsMobile] = useState(false);


  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
      setIsMobile(window.innerWidth < 768);
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);


  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      dispatch(login());
    }
  }, [dispatch, isAuthenticated]);

  if (isMobile) {
    return (
      <div className="fixed inset-0 bg-gray-800 bg-opacity-90 flex items-center justify-center z-50">
        <div className="text-center text-white">
          <h1 className="text-2xl font-bold">Web App Unavailable</h1>
          <p className="mt-2">This app is not available for mobile devices. Please use a larger screen.</p>
        </div>
      </div>)
  }

  return (
    <div className="">

      <Router>
        <ErrorBoundary
          FallbackComponent={UnauthorizedIndex}
        >

          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/termsAndConditions" element={<TermsAndConditions />} />

            <Route path="" element={<NotFoundPage />} />

            <Route
              path="/unauthorized"
              element={
                <UnauthorizedIndex />
              }

            />

            <Route
              element={<PrivateRoute allowedRoles={["admin", "carSeller"]} />}
            >
              <Route path="/home" element={<HomePage />} />
              <Route path="/services" element={<Services />} />
              <Route path="/usedCars" element={<UsedCars />} />
              <Route path="/sparePart" element={<SpareParts />} />
              <Route path="/chat" element={<Chat />} />
              <Route path="/offers" element={<Offers />} />
              <Route path="/reminder" element={<Reminder />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/orderHistory" element={<OrderHistory />} />
              <Route path="/enquiries" element={<UsedCarsEnquiriesTabel />} />
              <Route path="/explore" element={<Explore />} />
            </Route>
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </ErrorBoundary>
      </Router>
    </div>
  );
}

export default App;
